
import { useTranslation } from "react-i18next";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import DateFilter from "../../Components/CommonComponent/Dropdown/DateFilter";
import { useContext, useEffect } from "react";
import { CommonContext } from "../../App";


function TabsButtonDashboard() {
  const { setDateRange, } = useContext(CommonContext);
  const location = useLocation();
  const { t } = useTranslation();
  const tabs = [
    { title: t("receiptsbtn"), path: "receipt-transactions" },
    // { title: t("payments"), path: "payment-receipt" },
    { title: t("paymentsbtn"), path: "payment-transactions" },
    { title: t("salesbtn"), path: "sales-table" },
    { title: t("purchasebtn"), path: "purchase-table" },
    { title: t("journalbtn"), path: "journal-entry" },
    // { title: t("dayBook"), path: "daily-reports" },
  ];


  return (
    <div>
      <header className="tabs-header bg-theme-webBackground   py-1 pt-2 rounded  sticky top-0 z-[990]   flex gap-3 justify-between   ">
        <div className="flex gap-3 ">
          {tabs.map((tab) => {
            const isActive =
              location.pathname === "/dashboard" && tab.path === "receipt-transactions"
                ? true
                : location.pathname.endsWith(tab.path);
            return (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={`tab no-underline rounded-1 h-7 mt-[3px] pt-[3px] text-sm  px-2  ${isActive
                 ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
              >
                {tab.title}
              </NavLink>
            );
          })}
        </div>

        <div className="" >
          <DateFilter
            storageKey="reports"
             customMode="single"
             availableFilters={[ "today", "yesterday", "custom"]}
             onChange={(r) => setDateRange({
            startDate: '',
            endDate: r.startDate
          })} />

        </div>
      </header>

      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}

export default TabsButtonDashboard;
